import React from "react";
import {
	PageTemplateProps,
	PageTemplate,
} from "src/components/common/PageTemplate";
import { SitesDataGrid } from "src/components/views/erp/common/sites/SitesDataGrid";

export interface SitesPageProps extends PageTemplateProps {}

export const SitesPage = React.memo((props: SitesPageProps) => {
	return (
		<PageTemplate {...props}>
			<SitesDataGrid />
		</PageTemplate>
	);
});
